import { RefObject } from 'react';

export const getHTMLBlobData = (ref: RefObject<HTMLDivElement>): Blob => {
  const newDoc = document.implementation.createHTMLDocument('PDF');
  Array.from(document.styleSheets).forEach((styleSheet: CSSStyleSheet) => {
    const isDifferentOriginStyles = styleSheet.href && new URL(styleSheet.href).origin !== window.location.origin;
    if (styleSheet.ownerNode && !isDifferentOriginStyles && styleSheet.cssRules.length) {
      const styleElement = document.createElement('style');
      const cssRulesArray = Array.from(styleSheet.cssRules);
      styleElement.textContent = cssRulesArray.reduce((acc, rule) => acc + (rule?.cssText ?? ''), '');
      newDoc.head.appendChild(styleElement);
    }
  });
  Array.from(document.fonts).forEach((font) => newDoc.fonts.add(font));
  const blob = new Blob([`<html>${newDoc.head.innerHTML}${ref?.current?.innerHTML}</html>`], {
    type: 'text/html',
  });
  return blob;
};

export const processArrayBuffer = (buffer: Buffer | ArrayBuffer): string => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  // Convert the int array to a binary string
  // We loop through the bytes, instead of using the Array in an apply(), since
  // String.fromCharCode().apply() hits a maximum size when the bytelength
  // is more than 65536 (which is the limit for apply()).
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return binary;
};

export const arrayBufferToBase64 = (buffer: Buffer | ArrayBuffer) => {
  // Convert to base64
  return window.btoa(processArrayBuffer(buffer));
};
